export default {"src":"/_next/static/media/logo-gradient.89bd530f.svg","height":644,"width":1065,"blurWidth":0,"blurHeight":0};